import { FLEET_CUSTOM_ROLE_ID_RANGE, FLEET_ROLE_ID_RANGE, UserRole } from '@ti/contracts'

export const isFleetRole = (roleId: UserRole) => {
  return (
    (roleId >= FLEET_ROLE_ID_RANGE[0] && roleId <= FLEET_ROLE_ID_RANGE[1]) ||
    (roleId >= FLEET_CUSTOM_ROLE_ID_RANGE[0] && roleId <= FLEET_CUSTOM_ROLE_ID_RANGE[1])
  )
}
